// console.log("script running mjr");

import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQZJ0wXSLrH_HJrYG6ST6X6uEnj712tFE",
  authDomain: "recipies-d48e1.firebaseapp.com",
  databaseURL: "https://recipies-d48e1-default-rtdb.firebaseio.com",
  projectId: "recipies-d48e1",
  storageBucket: "recipies-d48e1.appspot.com",
  messagingSenderId: "135559238792",
  appId: "1:135559238792:web:b94a200985341d2d957b3d",
  measurementId: "G-JHX34WVLKS"
};

var element = document.querySelector(".product-template-2 h1.productTitleMjr");
var text = element.textContent.trim();

// Replace the first occurrence of " - " after the first word
let htmlLang = document.documentElement.lang;

if (htmlLang === 'en') {
  // text = text.replace(/^([^\s]+)\s+-\s+/, '$1 Formulation ');
  text = "Formulation "+text
} else {
  // text = text.replace(/^([^\s]+)\s+-\s+/, '$1 Formulierung ');
  // text = text.replace(/^([^\s]+)\s+–\s+/, '$1 Formulierung ');
  text = "Formulierung "+text
}


// Clean up extra spaces just in case
text = text.replace(/\s+/g, ' ').trim();

// Set the updated text back to the element
element.textContent = text;


// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

const recipeRef = collection(db, "recipe");

const printRecipe = async (recipeRef, product_id) => {
  const q = query(recipeRef, where("productId", "==", product_id));
  const recipeQuerySnapshot = await getDocs(q);

  const recipe = [];
  recipeQuerySnapshot.forEach((doc) => {
    recipe.push(doc.data());
  });

  return recipe;
};


let product_id = document.querySelector(
  "form.product-form input[name='product-id']"
).value;

let alrecipe = await printRecipe(recipeRef, parseInt(product_id));

console.log(alrecipe)

// index - title
let productIndexNumber = alrecipe[0].indexNumber
let productTitle = productIndexNumber+" "+alrecipe[0].title

// price
let productPrice = alrecipe[0].price

//meta fields
let metaEffect = alrecipe[0].effects
let metaTargets = alrecipe[0].targets
let metaActives = alrecipe[0].actives
let metaSkinType = alrecipe[0].skin_type
let metaFormat = alrecipe[0].format

// video url
// let videoUrl = alrecipe[0].video_url

// feature tabs
let tabDescription = alrecipe[0].description
let tabBenefits = alrecipe[0].benifts
let tabHowToUse = alrecipe[0].how_to_use

// icons
let iconCruely = alrecipe[0].cruelyFree
let iconNatural = alrecipe[0].natural
let iconParabenFree = alrecipe[0].parabenFree
let iconVegan = alrecipe[0].vegan
let iconGMO = alrecipe[0].GMO
let iconShowFragrance = alrecipe[0].show_fragrance

let images = alrecipe[0].images

jQuery(document).ready(function ($) {
  jQuery(".bacurr-cur-blocker.mjr").css("opacity", "1")
  // $("h1.productTitleMjr").text(productTitle)
  // $("span#ProductPriceMJR").text("$"+parseInt(productPrice).toFixed(2))
  
  // if(metaEffect != ""){
  //   $("#effect .info-product").text(metaEffect)
  // }else{
  //   $("#effect").hide();
  // }
  
  // if(metaTargets != ""){
  //   $("#targets .info-product").text(metaTargets)
  // }else{
  //   $("#targets").hide();
  // }
  
  // if(metaActives != ""){
  //   $("#actives .info-product").text(metaActives)
  // }else{
  //   $("#actives").hide();
  // }
  
  // if(metaSkinType != ""){
  //   $("#skintype .info-product").text(metaSkinType)
  // }else{
  //   $("#skintype").hide();
  // }
  
  // if(metaFormat != ""){
  //   $("#format .info-product").text(metaFormat)
  // }else{
  //   $("#format").hide();
  // }

  // features tabs
  // if (tabDescription) {
  //   $("#gtab1").removeClass("d-none")
  //   $(".nav-item[href='#gtab1']").removeClass("d-none")
  //   $("#gtab1").text(tabDescription)
  // }
  // if (tabBenefits) {
  //   $("#stab1").removeClass("d-none")
  //   $(".nav-item[href='#stab1']").removeClass("d-none")
  //   $("#stab1").text(tabBenefits)
  // }
  // if (tabHowToUse) {
  //   $("#stab2").removeClass("d-none")
  //   $(".nav-item[href='#stab2']").removeClass("d-none")
  //   $("#stab2").text(tabHowToUse)
  // }

  // video url
  // $("div#productVideoMjr video").attr("src", videoUrl)

  // Product images
  // let images_html = "";
  // let imageEle = "";
  // if (images.length) {
  //   $.each(images, function( index, value ) {
  //     imageEle = '<figure itemprop="associatedMedia" itemscope="" itemtype="http://schema.org/ImageObject" class="product-single__photo product__photo-container product__photo-container-template--20251572601162__template-product js" style="max-width: 480px;" data-image-id="53916183429450">';
  //       imageEle += '<a href="'+value+'" itemprop="contentUrl" data-size="1400x1400" class="product__photo-wrapper product__photo-wrapper-template--20251572601162__template-product zoom_image zoom zoom_enabled" style="padding-top: 100%; position: relative; overflow: hidden;">';
  //         imageEle += '<img itemprop="thumbnail" class="lazyautosizes lazyloaded" src="'+value+'" data-widths="[180, 240, 360, 480, 720, 960, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="test recipe1" data-srcset="" sizes="375px">';
  //       imageEle += '</a>';
  //     imageEle += '</figure>';
  //     images_html += imageEle;
  //   });
  //   $(".my-gallery").html(images_html).css("display", "flex");
  //  $('.zoom').zoom(
  //       {
  //           magnify: 0.3
  //       }
  //   );
  // }
  
  // small icons
  // if(iconCruely){
  //   $("#iconCruely").removeClass("d-none")
  // } 
  // if(iconNatural){
  //   $("#iconNatural").removeClass("d-none")
  // }
  // if(iconParabenFree){
  //   $("#iconParabenFree").removeClass("d-none")
  // } 
  // if(iconVegan){
  //   $("#iconVegan").removeClass("d-none")
  // } 
  // if(iconGMO){
  //   $("#iconGMO").removeClass("d-none")
  // } 
  // if(iconShowFragrance){
  //   $("#iconShowFragrance").removeClass("d-none")

  //   // Product images
  //   let images_html = "";
  //   let imageEle = "";
  //   let frImgUrl = jQuery(".my-gallery").attr("data-fr-image");
  //   imageEle = '<figure itemprop="associatedMedia" itemscope="" itemtype="http://schema.org/ImageObject" class="product-single__photo product__photo-container product__photo-container-template--20251572601162__template-product js" style="max-width: 480px;" data-image-id="53916183429450">';
  //     imageEle += '<a href="'+frImgUrl+'" itemprop="contentUrl" class="product__photo-wrapper product__photo-wrapper-template--20251572601162__template-product zoom_image fr_zoom zoom zoom_enabled" style="padding-top: 100%; position: relative; overflow: hidden;">';
  //       imageEle += '<img itemprop="thumbnail" class="lazyautosizes lazyloaded" src="'+frImgUrl+'" >';
  //     imageEle += '</a>';
  //   imageEle += '</figure>';
  //   images_html += imageEle;
    
  //   $(".my-gallery").prepend(images_html).css("display", "flex");
  //     $('.zoom.fr_zoom').zoom(
  //           {
  //               magnify: 0.3
  //           }
  //     );
  // }

  // function set_price() {
  //   let price = parseInt(alrecipe[0].price)
  //   let variable = jQuery(".mjr.product-form__item select").val()
  //   let new_price = "";
  //   switch(variable){
  //           case "100ml":
  //           new_price = "$"+price.toFixed(2)
  //               break;
            
  //           case "150ml":
  //           new_price = "$"+(price*1.5).toFixed(2)
  //               break;
            
  //           case "200ml":
  //           new_price = "$"+(price*2).toFixed(2)
  //               break;
            
  //           case "250ml":
  //           new_price = "$"+(price*2.5).toFixed(2)
  //               break;
            
  //           case "500ml":
  //           new_price = "$"+(price*5).toFixed(2)
  //               break;
  //   }
  //   $("span#ProductPriceMJR").text(new_price)
  // }
  // set_price();
  
  // Keeping cart button title
  jQuery(".mjr.product-form__item select").change(function () {
    // debugger;
    jQuery(".mjr.product-form__item").siblings("a.product-form__cart-submit").find("span").text("Produce now")
    jQuery("span#current_variant").text("/"+jQuery(this).val())
    // set_price()
  })

  if($(window).width() <= 480){
    $('.mjr-gallery').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1500,
        arrows: true,
        dots: true,
        pauseOnHover: true,
        prevArrow: '<div class="swiper-button-prev">&#10094;</div>',
        nextArrow: '<div class="swiper-button-next">&#10095;</div>',
        responsive: [ {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }]
    });
  }


  // let currentIndex = 0;

  //   const $swiperWrapper = $('.swiper-wrapper');
  //   const $slides = $('.swiper-slide');
  //   const totalSlides = $slides.length;

  //   function showSlide(index) {
  //       if (index >= totalSlides) {
  //           // currentIndex = 0;
  //         return;
  //       } else if (index < 0) {
  //         return;
  //           // currentIndex = totalSlides - 1;
  //       } else {
  //           currentIndex = index;
  //       }
  //       const offset = -currentIndex * 100;
  //       $swiperWrapper.css('transform', `translateX(${offset}%)`);
  //   }

  //   $('.swiper-button-next').click(function() {
  //       showSlide(currentIndex + 1);
  //   });

  //   $('.swiper-button-prev').click(function() {
  //       showSlide(currentIndex - 1);
  //   });

  //   // Optionally, you can add swipe support for touch devices
  //   let startX;
  //   $swiperWrapper.on('touchstart', function(e) {
  //       startX = e.originalEvent.touches[0].clientX;
  //   });

  //   $swiperWrapper.on('touchmove', function(e) {
  //       const touch = e.originalEvent.touches[0];
  //       const diffX = startX - touch.clientX;

  //       if (diffX > 50) {
  //           showSlide(currentIndex + 1);
  //           startX = touch.clientX;
  //       } else if (diffX < -50) {
  //           showSlide(currentIndex - 1);
  //           startX = touch.clientX;
  //       }
  //   });

  jQuery("select#SingleOptionSelector-0").change(function(){
      jQuery(".product-single__price-container").css('opacity', '0')
      // alert("issue found")
      window.location.reload()
    })
    // alert("loaded")
})// End Doc
